module.exports = __webpack_public_path__ + "media/images/icons/icon_share_grey-b1ed30febcbe5901a1d448a788fcf226.svg";